import React from 'react'
import PropTypes from 'prop-types'
import { formatPrice, isNotEmpty, date, constants, getAddress } from 'common/helpers'

import Box from 'components/_new/layout/Box/Box'
import Title from 'components/_new/typography/deprecated/Title/Title'
import Card from 'components/_new/layout/Card/Card'
import Text from 'components/_new/typography/Text/Text'
import Row from 'components/_new/layout/Row/Row'
import ProductCardBase from 'components/_new/productCard/ProductCardBase/ProductCardBase'
import DeliveryStatus from 'components/_new/DeliveryStatus/DeliveryStatus'
import Href from 'components/_new/ui/Href/Href'

import messages from './messages'
import s from './Order.scss'


const Order = ({ products, tracking, shipping, orderNo, charge }) => {
  const status = !tracking ? constants.deliveryStatuses.processing.toLowerCase() : tracking.status
  const { totalPrice, paymentDate } = charge || {}

  const shippingAddress = getAddress(shipping)

  return (
    <Box>
      <Card size="md" withBg>
        {
          Boolean(orderNo) && (
            <Title message={messages.title} values={{ orderNo }} size="sm" />
          )
        }
        <Box mb="24">
          <Text message={shippingAddress} size="14-24" />
        </Box>
        <Row>
          <div>
            {
              Boolean(paymentDate) && (
                <Text size="14-24" html message={messages.date} values={{ billingDate: date.formatDate(paymentDate, 'MMMM Do') }} />
              )
            }
            <Box mt="8" mb="16">
              {
                Boolean(totalPrice) && (
                  <Text size="14-24" html message={messages.total} values={{ total: formatPrice(totalPrice, true) }} />
                )
              }
            </Box>
            <DeliveryStatus status={status} />
          </div>
          <div className={s.products}>
            {
              isNotEmpty(products) && products.map(({ id, url, name, brand, image, upchargePrice }) => (
                <Href key={id} to={url} className={s.product} title={`${brand} ${name}`}>
                  <ProductCardBase
                    image={image}
                    imageAspectRatio={80 / 88}
                    upchargePrice={upchargePrice}
                  />
                </Href>
              ))
            }
          </div>
        </Row>
      </Card>
    </Box>
  )
}

Order.propTypes = {
  products: PropTypes.arrayOf(PropTypes.shape({
    id: PropTypes.number,
    name: PropTypes.string,
    brand: PropTypes.string,
    image: PropTypes.string,
    url: PropTypes.string,
    upchargePrice: PropTypes.number,
  })),
  tracking: PropTypes.shape({
    status: PropTypes.string,
  }),
  orderNo: PropTypes.string,
  charge: PropTypes.shape({
    totalPrice: PropTypes.number,
    paymentDate: PropTypes.string,
  })
}


export default Order
